import IFeedbackServiceClient from './IFeedbackServiceClient';
import FeedbackServiceClient from './FeedbackServiceClient';

class FeedbackServiceFactory {
  public static create(): IFeedbackServiceClient {
    if (!FeedbackServiceFactory.instance) {
      FeedbackServiceFactory.instance = new FeedbackServiceClient();
    }
    return FeedbackServiceFactory.instance;
  }

  private static instance: IFeedbackServiceClient;
}

export default FeedbackServiceFactory;
